<template>
  <div>
    <div class="text-xl mt-2" v-html="topic.teaser"></div>
    <div class="text-3xl font-medium" v-html="topic.title"></div>

    <div class="grid grid-cols-1 md:grid-cols-2 mt-6 sm:mt-16">
      <subject-index></subject-index>
      <div>
        <img v-if="topic.image" :src="topic.image" class="mb-6">
        <div class="font-normal text-lg" v-html="topic.description"></div>
      </div>
    </div>

    <pre v-if="debug" class="mt-24">
    {{ topic }}
    </pre>

  </div>
</template>

<script>

import { mapState, mapGetters, mapMutations } from 'vuex'
import SubjectIndex from '../components/subject_index.vue'

export default {
  data() {
    return {
      debug: false
    }
  },
  computed: {
    ...mapGetters(['selected_topic']),
    topic() {
      return this.selected_topic(this.$route.params.id)
    }
  },
  components: {
    SubjectIndex
  }
}
</script>